import { forwardRef } from 'react';
import { Form } from 'react-bootstrap';

const CampoMedida = forwardRef(function CampoMedida(
  { label, value, unit = '', editable = false, onChange, placeholder = '', onEnterPress },
  ref
) {
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      onEnterPress?.();
    }
  };

  return (
    <div className="legacy-metric-row">
      <div className="legacy-metric-label">
        {label}
        {unit ? ` (${unit})` : ''}:
      </div>
      <div className="legacy-metric-value">
        <Form.Control
          ref={ref}
          type="text"
          value={value ?? ''}
          onChange={(e) => onChange?.(e.target.value)}
          onKeyDown={editable ? handleKeyDown : undefined}
          readOnly={!editable}
          placeholder={placeholder || label}
          className="legacy-input"
        />
      </div>
    </div>
  );
});

export default CampoMedida;
